
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.545 8a5.455 5.455 0 1110.91 0 5.455 5.455 0 01-10.91 0zM8 1.333a6.667 6.667 0 100 13.334A6.667 6.667 0 008 1.334zm1.274 10.11l.104-.427a1.79 1.79 0 01-.26.088c-.12.033-.228.05-.323.05-.202 0-.344-.034-.426-.1-.082-.066-.123-.19-.123-.374 0-.072.013-.18.038-.322.025-.142.054-.268.085-.379l.388-1.378c.038-.126.064-.265.079-.416.014-.152.02-.257.02-.317a.904.904 0 00-.305-.708c-.203-.182-.493-.273-.868-.273-.209 0-.43.038-.663.112a9.868 9.868 0 00-.734.267l-.104.426c.075-.028.166-.058.272-.09.106-.031.209-.047.31-.047.205 0 .344.035.417.104.072.07.109.193.109.37 0 .097-.012.206-.036.324a6.596 6.596 0 01-.088.376l-.388 1.383c-.034.145-.06.275-.076.39a2.494 2.494 0 00-.023.34c0 .283.105.518.315.702.21.185.504.277.883.277.246 0 .462-.032.648-.097.187-.065.436-.159.748-.282zm-.07-5.595a.807.807 0 00.273-.613c0-.24-.09-.445-.272-.616a.924.924 0 00-.656-.255.932.932 0 00-.658.255.811.811 0 00-.275.616c0 .24.092.444.275.613a.937.937 0 00.658.253.929.929 0 00.656-.253z"}})])
          )
        }
      }
    